import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GuideEditor } from '@/admin/publishing/GuideEditor';
import { DetailPage } from '@/admin/ui/Editor';
import { PageTitle } from '@/admin/ui/Page';
import api from '@/api';

export const Route = createFileRoute('/admin/bible/guides/$guideId')({
  staticData: { minTier: 'ADMIN' },
  component: GuidePage,
});

function GuidePage() {
  const { t } = useTranslation();
  const { guideId } = Route.useParams();
  const [epoch, setEpoch] = useState(0);
  const query = api.adminGetStudyGuide.useQuery({
    path: { guide_id: Number(guideId) },
  });
  if (query.isLoading)
    return <Message>{t('admin.publishing.guides.loading')}</Message>;
  if (query.error || !query.data)
    return (
      <Message $error>{t('admin.publishing.guides.errorLoading')}</Message>
    );
  return (
    <DetailPage>
      <div>
        <Link to="/admin/bible/guides/">
          {t('admin.publishing.guides.back')}
        </Link>
        <PageTitle>{query.data.title}</PageTitle>
      </div>
      {/* Keyed on the id, not the revision: a refetch must not drop unsaved edits.
          The editor bumps `epoch` after its own save to re-seed. */}
      <GuideEditor
        key={`${query.data.id}:${epoch}`}
        guide={query.data}
        onReseed={() => setEpoch((n) => n + 1)}
      />
    </DetailPage>
  );
}

const Message = styled.div<{ $error?: boolean }>`
  color: ${(p) => (p.$error ? 'var(--error)' : 'var(--grey-600)')};
  padding: 2rem;
  text-align: center;
`;
